<template>
    <b-form>
        <b-form-group id="comments-group" :label="$translate('comments')" label-for="input-comments" label-cols="12" label-cols-md="3"
            label-class="font-weight-bold pt-0">
            <b-form-textarea type="text" id="input-comments" v-model="model.comments" required
                :placeholder="$translate('enter_comments')" rows="3" max-rows="6"></b-form-textarea>
        </b-form-group>
        <p>{{$translate('notes')}} : {{ model.notes }} </p>
        <div class="form-check">
            <label class="form-check-label ms-4 lh-base">
                <input type="checkbox" class="form-check-input top-2" id="input-completed" v-model="model.completed"
                    name="input-completed" :value="1" :unchecked-value="0" />
                {{ $translate('completed') }}
                <i class="input-helper"></i>
            </label>
        </div>
        <b-form-group id="comments-group" class="mt-2" :label="$translate('signature')" label-for="input-comments" label-cols="12" label-cols-md="3"
            label-class="font-weight-bold pt-0">
            <div class="border border-dark">
                <vueSignature ref="signature" v-model="model.signature_data" :w="'800px'" :h="'200px'">
                </vueSignature>
            </div>
            <div class="mt-2">
                <b-button id="view-checkoff-clear-btn" @click="clear">{{$translate('clear')}}</b-button>
                <b-button id="view-checkoff-undo-btn" @click="undo">{{$translate('undo')}}</b-button>
            </div>
        </b-form-group>
    </b-form>
</template>

<script>
import permissionsMixins from '@/mixins/permissionsMixins'
import vueSignature from "vue-signature"

export default {
    name: 'orders-viewCheckoffForm',
    mixins: [permissionsMixins],
    components: {
        vueSignature,
    },
    data: () => ({
        model: {
            signature_data: null
        },
    }),
    props: ['value', 'status'],
    watch: {
        model: {
            handler: function (val) {
                console.log("val", val)
                this.$emit('input', val)
            },
            deep: true,
        },
    },
    mounted() {
        this.model = { ...this.value }
    },
    methods: {
        saveSignature() {
            var _this = this;
            console.log('Signature is null!', _this.$refs.signature.isEmpty() == true);
            if (_this.$refs.signature.isEmpty()) {
                _this.model.signature_data = null
            } else {
                _this.model.signature_data = _this.$refs.signature.save();
            }
        },
        clear() {
            var _this = this;
            _this.$refs.signature.clear();
        },
        undo() {
            var _this = this;
            _this.$refs.signature.undo();
        },
    }
}
</script>
